export default {
  isSupported: false,
  extractTextFromImage: async (uri: string) => [],
};
